import _ from 'underscore';
import {SYSTEM_ATTRIBUTE_LABELS} from '../locales';
import {AttributeTemplate} from '../types';

export const getLabel = (attr: AttributeTemplate, escape = false) => {
	const label = attr.system
		? SYSTEM_ATTRIBUTE_LABELS[attr.attributeid] ?? i18n.t(`i18n.${attr.name}`)
		: attr.name;

	return escape ? _.escape(label) : label;
};

export default getLabel;
